import React from "react";

const PackageSkeletonBody = () => {
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {
            Array.from({ length: 3 }).map((_, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all duration-300 hover:shadow-2xl"
              >
                {/* Skeleton Tag */}
                <div className="bg-gradient-to-r from-gray-300 to-gray-400 animate-pulse h-8 md:h-10"></div>

                {/* Skeleton Package Content */}
                <div className="md:p-8 p-4">
                  {/* Skeleton Title */}
                  <div className="h-7 bg-gray-300 rounded animate-pulse mb-2"></div>

                  {/* Skeleton Description */}
                  <div className="space-y-2 mb-6">
                    <div className="h-4 bg-gray-300 rounded animate-pulse w-full"></div>
                    <div className="h-4 bg-gray-300 rounded animate-pulse w-3/4"></div>
                  </div>

                  {/* Skeleton Price */}
                  <div className="mb-6">
                    <div className="flex md:flex-row flex-col items-baseline">
                      <div className="h-9 bg-gray-300 rounded animate-pulse w-24"></div>
                      <div className="h-4 bg-gray-300 rounded animate-pulse w-32 ml-2 mt-1"></div>
                    </div>
                  </div>

                  {/* Skeleton Features */}
                  <div className="space-y-3 mb-8">
                    {Array.from({ length: 4 }).map((_, featureIndex) => (
                      <div key={featureIndex} className="flex items-start">
                        <div className="w-5 h-5 bg-gray-300 rounded-full mr-3 flex-shrink-0 mt-0.5 animate-pulse"></div>
                        <div className="h-4 bg-gray-300 rounded animate-pulse w-full"></div>
                      </div>
                    ))}
                  </div>

                  {/* Skeleton Action Buttons */}
                  <div className="flex gap-3">
                    <div className="flex-1 h-12 bg-gray-300 rounded-lg animate-pulse"></div>
                    <div className="flex-1 h-12 bg-gray-300 rounded-lg animate-pulse"></div>
                  </div>
                </div>
              </div>
            ))
        }
      </div>
    </div>
  );
};

export default PackageSkeletonBody;
